/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import styles from './styles.scss';


const defaultProps = {
  show: false,
  onHide: () => {},
  azStyle: 'default',
};

const propTypes = {
  message: React.PropTypes.string.isRequired,
  show: React.PropTypes.bool,
  onHide: React.PropTypes.func,
  azStyle: React.PropTypes.oneOf([
    'success',
    'primary',
    'danger',
    'info',
    'warning',
    'default',
  ]),
};

class Flash extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: props.message,
      show: props.show,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { message, show } = nextProps;
    if (message !== this.props.message) {
      this.setState({ message });
    }
    if (show !== this.props.show) {
      this.setState({ show });
      if (show) {
        const { onHide } = nextProps;
        const that = this;
        setTimeout(() => {
          that.setState({ show: false });
          onHide();
        }, 1500);
      }
    }
  }

  render() {
    const { azStyle } = this.props;
    const { message, show } = this.state;
    let flash;
    if (show) {
      flash = (
        <div key="flash" className={`${styles.flash} ${styles[azStyle]}`}>
          <div className={styles.content}>
            {message}
          </div>
        </div>
      );
    }
    return (
      <ReactCSSTransitionGroup
        transitionName={{
          enter: styles.enter,
          enterActive: styles.enterActive,
          leave: styles.leave,
          leaveActive: styles.leaveActive,
          appear: styles.appear,
          appearActive: styles.appearActive,
        }}
        transitionAppear
        transitionAppearTimeout={100}
        transitionEnterTimeout={100}
        transitionLeaveTimeout={300}
      >
        {flash}
      </ReactCSSTransitionGroup>
    );
  }
}

Flash.defaultProps = defaultProps;
Flash.propTypes = propTypes;

export default Flash;




// WEBPACK FOOTER //
// ./src/components/Flash/index.jsx